export function countUp() {
  const counters = document.querySelectorAll(".js-countUp");
  
  if (counters.length === 0) return;

  const observerOptions = {
    threshold: 0, // 要素が画面の10%表示されたら実行
    rootMargin: "0px" // 要素が画面の上から10%下に入ってから実行（画面外の要素を検出しない）
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        counter.innerText = "0";
        
        const updateCount = () => {
          const target = +counter.getAttribute("data-target");
          const current = +counter.innerText;
          const increment = target / 50; // 50回の更新で完了
          if (current < target) {
            counter.innerText = `${Math.ceil(current + increment)}`;
            setTimeout(updateCount, 10); // 10msごとに更新（合計約0.5秒）
          } else {
            counter.innerText = target;
          }
        };
        
        updateCount();
        observer.unobserve(counter);
      }
    });
  }, observerOptions);

  counters.forEach((counter) => {
    observer.observe(counter);
  });
}